const topics = [
  {
    tag: '今日最热',
    title: '某顶流艺人恋情曝光，粉丝集体破防',
    desc: '昨日深夜，有媒体拍到某一线顶流与神秘女子同回住所，持续发酵中...',
    image: 'https://readdy.ai/api/search-image?query=Warm%20toned%20abstract%20illustration%20of%20celebrity%20news%20and%20entertainment%20gossip%20with%20soft%20gradients%2C%20paparazzi%20style%20silhouettes%2C%20magazine%20editorial%20aesthetic%2C%20coral%20and%20cream%20color%20palette%2C%20minimal%20flat%20design%20with%20news%20elements&width=800&height=500&seq=carousel-01&orientation=landscape',
  },
  {
    tag: '持续追踪',
    title: '热播剧大结局争议不断，编剧回应了',
    desc: '年度爆款剧集迎来大结局，但口碑两极分化，编剧深夜发文回应...',
    image: 'https://readdy.ai/api/search-image?query=Teal%20and%20warm%20toned%20illustration%20about%20drama%20series%20and%20television%20entertainment%2C%20cinematic%20composition%20with%20film%20elements%2C%20modern%20flat%20vector%20style%2C%20soft%20gradients%2C%20editorial%20photography%20aesthetic&width=800&height=500&seq=carousel-02&orientation=landscape',
  },
  {
    tag: '深度扒皮',
    title: '网红带货翻车事件全梳理，金额惊人',
    desc: '知名带货主播被曝虚假宣传，涉及金额超千万，消费者维权进行时...',
    image: 'https://readdy.ai/api/search-image?query=Coral%20and%20cream%20toned%20illustration%20of%20live%20streaming%20and%20social%20media%20commerce%2C%20modern%20flat%20vector%20art%20with%20phone%20and%20shopping%20elements%2C%20soft%20gradient%20background%2C%20editorial%20style&width=800&height=500&seq=carousel-03&orientation=landscape',
  },
  {
    tag: '独家揭秘',
    title: '综艺节目幕后黑幕被参赛者曝光',
    desc: '前选秀节目参赛者深夜发文，揭露节目组暗箱操作内幕，引发热议...',
    image: 'https://readdy.ai/api/search-image?query=Warm%20toned%20illustration%20of%20talent%20show%20and%20variety%20program%20behind%20the%20scenes%2C%20stage%20and%20spotlight%20elements%2C%20modern%20flat%20vector%20style%2C%20soft%20gradients%2C%20teal%20and%20coral%20accents&width=800&height=500&seq=carousel-04&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 px-4 md:px-6 bg-background-100 scroll-mt-20">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            热门专题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            本周最受关注的吃瓜专题，每一条都值得细品
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {topics.map((item, i) => (
            <div
              key={i}
              className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 hover:border-primary-200/60 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-3 py-1 bg-primary-500 text-white text-xs font-medium rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 mb-2 line-clamp-2 leading-snug">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}